import React from 'react';
import T from 'prop-types';

import PageNav from '../PageNav';
import skeletons from '../Skeletons';

const ForecastsCompanyHeader = ({
  pending,
  activeTab,
  forecasts,
  availableKpis,
  quartersDropdown,
  downloadButton,
  onTabChange,
}) => (
  <div className="forecasts-filters">
    {pending ? (
      skeletons.forecastsFilters
    ) : (
      <>
        <PageNav
          pagesList={availableKpis || forecasts}
          active={activeTab}
          variant="dropdown"
          onChange={onTabChange}
        />
        {quartersDropdown}
        <div className="ml-auto">{downloadButton}</div>
      </>
    )}
  </div>
);

ForecastsCompanyHeader.propTypes = {
  pending: T.bool.isRequired,
  activeTab: T.string,
  forecasts: T.array,
  availableKpis: T.array,
  quartersDropdown: T.node,
  downloadButton: T.node,
  onTabChange: T.func.isRequired,
};

export default ForecastsCompanyHeader;
